import React from 'react'
import { Card, Typography } from 'antd'
import ReminderCard from './ReminderCard'

const { Text } = Typography

const ReminderCardList = ({ reminders, onAcknowledge, onEdit }) => {
  if (!reminders || reminders.length === 0) {
    return (
      <Card>
        <Text>No upcoming reminders match your filters.</Text>
      </Card>
    )
  }

  return (
    <div className='reminder-cards-container'>
      {reminders.map((reminder) => (
        <ReminderCard key={reminder.reminderId} reminder={reminder} onAcknowledge={onAcknowledge} onEdit={onEdit} />
      ))}
    </div>
  )
}

export default ReminderCardList
